// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1LG7z","legacyBtn":"MutateMid_legacyBtn__2wnw3"};